import React, { Fragment } from 'react';

const TooltipsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-row">
        <div className="left">
          <h1 className="h1 page-title">
            Tooltips provide additional information upon hover or focus.
          </h1>
        </div>
        <div className="right copy-content">
          <p>Tooltips are used to help users understand the meaning or purpose of a determined element and they often contain helper text that is contextual to each element. The content can be adjusted according to the user experience needs, composed of different and independent elements, that can adapt to the needed content.</p>
        </div>
      </article>
    </section>

    <section className="bg-grey with-padding flex-grow-1">
      <article className="flex-justify-end flex-row last">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Pointer Position</h2>
          <p>The position of the tooltips is flexible and will change depending on where the trigger placement is on a given composition. The UX Designer can override the default pointer rules in specific cases, as when tooltips cover some important information or composition.</p>
          <h2 className="h2 page-subtitle">Colours</h2>
          <p>There are 3 colours variations for the tooltips and they should be used considering the different contexts where they will be used: the primary colour is the black and it’s used in most cases. As a secondary colour, the UX Designer can choose to use purple in case he thinks that it needs to be highlighted. In dark backgrounds, the white colour must be used to provide a better contrast.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default TooltipsUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/TooltipsUsage.js